import {Close} from '@mui/icons-material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import {MouseEvent, ReactNode} from 'react';
import LegacyIconButton from '../LegacyIconButton';

export type LegacyDeletableListItem = {
  id: string;
  label: ReactNode;
};

export type LegacyDeletableListProps = {
  items: readonly LegacyDeletableListItem[];
  onDeleteItem: (id: string) => void;
  onItemClick: (id: string) => void;
  title: ReactNode;
};

const LegacyDeletableList = ({items, onDeleteItem, onItemClick, title}: LegacyDeletableListProps) => (
  <div>
    <Typography variant="h6" component="h2" gutterBottom>
      {title}
    </Typography>
    <div data-testid="legacy-deletable-list-scroll" style={{maxHeight: 400, overflowY: 'auto'}}>
      <List>
        {items.map(item => (
          <ListItem
            key={item.id}
            disablePadding
            secondaryAction={
              <LegacyIconButton
                edge="end"
                aria-label="delete"
                onClick={(event: MouseEvent<HTMLButtonElement>) => {
                  event.stopPropagation();
                  onDeleteItem(item.id);
                }}>
                <Close />
              </LegacyIconButton>
            }>
            <ListItemButton onClick={() => onItemClick(item.id)} sx={{paddingRight: '48px'}}>
              <ListItemText primary={<Typography variant="body2">{item.label}</Typography>} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  </div>
);

export default LegacyDeletableList;
